// extracted by mini-css-extract-plugin
export default {"container":"Header_container__ND8Rv","heading":"Header_heading__tEPjA","right":"Header_right__WDhgT"};